import { styled } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

export const StyledMenu = styled(Menu)({
  marginTop: "20px",
  "& .MuiPaper-root": {
    borderRadius: "4px",
    width: "300px",
    maxWidth: "300px",
    backgroundColor: "#ffff",
    boxShadow: 3,
    position: "relative",
    overflow: "visible",
    boxSizing: "border-box",
  },
});

export const ProfileAvatarContainer = styled(Box)({
  position: "absolute",
  top: -43,
  right: 20,
  zIndex: 2,
});

export const MenuSectionsContainer = styled(Box)({
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  overflow: "hidden",
});

export const StyledProfileAvatar = styled(Avatar)({
  width: 80,
  height: 80,
  border: "2px solid white",
  backgroundColor: "white",
  color: "#333",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
});

export const ProfileInfoSection = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(12),
  paddingBottom: 0,
}));

export const UserName = styled(Typography)({
  color: "#333333",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
  textTransform: "capitalize",
  wordWrap: "break-word",
  wordBreak: "break-all",
  maxWidth: "180px",
});

export const UserEmail = styled(Typography)({
  color: "#333333",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "20px",
  textTransform: "lowercase",
  wordWrap: "break-word",
  marginTop: "5px",
});

export const RolePill = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  width: "auto",
  maxWidth: "100%",
  padding: "3px 10px",
  borderRadius: "999px",
  backgroundColor: "#E8F0FE",
  color: "#1A6BE8",
  fontSize: "11px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.02em",
  textTransform: "capitalize",
  border: "1px solid #C5DAFC",
  whiteSpace: "normal",
  wordBreak: "break-word",
  alignSelf: "flex-start",
});

export const RolesPillsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  marginTop: "8px",
});

export const RolesPanelSubtitle = styled(Typography)({
  color: "#5C5C5C",
  fontSize: "13px",
  fontWeight: 500,
  lineHeight: "18px",
  marginTop: "2px",
});

export const UserPhone = styled(Typography)({
  color: "#333333",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "20px",
  marginTop: "8px",
});

export const StyledDivider = styled(Divider)({
  width: "85% !important",
  border: "1px solid #b2b2b2 !important",
  margin: "10px 0 !important",
  opacity: "1 !important",
  marginTop: 15,
  marginBottom: 18,
  marginLeft: "15px !important",
  paddingLeft: "16px !important",
});

export const StyledAccordion = styled(Accordion)({
  boxShadow: "none",
  transition: "none",
  paddingLeft: "16px",
  paddingRight: "16px",
  paddingTop: "8px",
  paddingBottom: "8px",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  "&:before": {
    display: "none",
  },
  "&.Mui-expanded": {
    margin: "auto",
  },
  fontWeight: "500 !important",
});

export const StyledAccordionSummary = styled(AccordionSummary)({
  minHeight: "30px !important",
  height: "auto !important",
  width: "100%",
  maxWidth: "100%",
  padding: "0 !important",
  boxSizing: "border-box",
  "& .MuiAccordionSummary-content": {
    margin: "0 !important",
    minWidth: 0,
    overflow: "hidden",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
});

export const AccordionSummaryRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  minWidth: 0,
  overflow: "hidden",
});

export const AccordionTitleBlock = styled(Box)({
  marginLeft: "8px",
  minWidth: 0,
  overflow: "hidden",
});

export const AccountSettingsLabel = styled(Typography)({
  color: "#333333",
  fontWeight: 500,
  textAlign: "left",
});

export const StyledHelpIcon = styled(QuestionMarkIcon)({
  marginRight: "8px",
  color: "#000000",
});

export const HelpLabel = styled(Typography)({
  color: "#333333",
  fontWeight: 500,
});

export const RolesAccordionDetails = styled(AccordionDetails)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  paddingLeft: "32px",
  paddingRight: "8px",
  paddingTop: 0,
  paddingBottom: 0,
  marginTop: "5px",
  marginLeft: 0,
});

export const StyledAccordionDetails = styled(AccordionDetails)({
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  paddingLeft: "32px",
  paddingRight: "8px",
  paddingTop: 0,
  paddingBottom: 0,
  marginTop: "5px",
  marginLeft: 0,
});

export const LogoutSection = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export const LogoutButton = styled(Button)(({ theme }) => ({
  width: "100%",
  marginTop: theme.spacing(1),
  backgroundColor: "#1A6BE8",
}));
